import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { EmptyState } from "@/components/app/lists/empty-state";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { orpc } from "@/lib/orpc";
import { CourseEditor } from "../-components/course-editor";

export const Route = createFileRoute("/_authenticated/_workforce/training/courses/$courseId/")({
  component: EditCourse,
});

/** The same builder as a new course, opened on one that already exists. */
function EditCourse() {
  const { courseId } = Route.useParams();
  const course = useQuery({
    ...orpc.workforce.training.getCourse.queryOptions({ input: { courseId } }),
    retry: false,
  });

  if (course.isPending) return <Skeleton className="h-96 w-full" />;
  if (course.isError || !course.data) {
    return (
      <EmptyState
        title="This course could not be opened"
        description="It may have been removed, or it belongs to a building you cannot see."
        action={
          <Button variant="outline" asChild>
            <Link to="/training/courses">Back to courses</Link>
          </Button>
        }
      />
    );
  }

  return <CourseEditor course={course.data} />;
}
